<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-card pa-0>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          ></v-text-field>     
          <!--<v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>-->
          <!--<router-link :to="{path: formPath}">
              <v-btn color="success" fab small dark>
                <v-icon>add</v-icon>
              </v-btn>  
          </router-link>-->              
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0 branch-scroll tabular">
          <v-data-table
            :headers="complex.headers"
            :search="search"
            :items="complex.items"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[-1]"
            class="elevation-1"
            hide-actions
            item-key="id"                            
            v-model="complex.selected"
            >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template slot="items" slot-scope="props"> 
              <tr @click="dapilRoute(props.item.id, props.item.mode)" style="cursor: pointer">                               
                <td><v-chip v-bind:color="props.item.color" dark>
                  <v-avatar class="grey">{{firstLetter(props.item.modeName )}}</v-avatar>{{ props.item.name }}</v-chip>                
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>        
    </div>
  </v-slide-y-transition>
</template>

<script>  
import kompetisi from '@/apps/frc/models/Kompetisi';    

var model = new kompetisi();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/kompetisi/form',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [              
              { text: 'Kompetisi', value: 'name', align:'center', sortable:false}
            ],
            items: []
        },
    }),  
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
                     
        firstLetter (name) {
            return name.charAt(0);
        },
        
        dapilRoute (id, mode) {
            this.$router.push({path:'/calon', query: {kompetisi_id: id, mode: mode}});
        },
    }
}
</script>
  
